var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.type=='anonymous')?_c('el-alert',{attrs:{"center":"","title":"匿名话题只能由此进入进行修改或删除","type":"success","closable":false}}):_vm._e(),_c('br')],1),_c('TopicCard',{key:this.id,attrs:{"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }